/**
 * 入口文件
 */

import ccRequest from './src/api/request.js';
import ccBaseUtils from './src/utils/baseUtils.js';

const prototypes = [
  ccRequest,
  ccBaseUtils
]


/* 注册为全局方法 */
ccRequest.install = function (Vue) {
  Vue.prototype.ccRequest = ccRequest
};

ccBaseUtils.install = function (Vue) {
  Vue.prototype.ccBaseUtils = ccBaseUtils
}

const install = function (Vue) {
  if (install.installed) return

  Vue.prototype.ccRequest = ccRequest
  Vue.prototype.ccBaseUtils = ccBaseUtils

}


export default {
  install,
  ccRequest,
  ccBaseUtils
}